import {
  FilterElement,
  InputGroupV2,
  UniversalSelect,
  MultiSelectOption,
} from '@equip.health/ui';

import { InquiryStatusDropdownMenuOptions } from '~/lib/constants/inquiry.constants';
import { formatOptionLabel } from '~/lib/util/inquiry.util';

const StatusOptions: MultiSelectOption[] = InquiryStatusDropdownMenuOptions.map(
  (status) => ({
    color: status.color,
    label: status.value,
    value: status.value,
  }),
);

interface StatusFilterProps {
  id: string;
  label: string;
  status: FilterElement[];
  onStatusChange: (status: FilterElement[]) => void;
}

const StatusFilter = ({
  id,
  label,
  status,
  onStatusChange,
}: StatusFilterProps) => {
  const handleStatusChange = (status: FilterElement[]) => {
    onStatusChange(status);
  };
  const TOP_LEVEL_ID = `${id}__status-filter`;
  return (
    <InputGroupV2 id={TOP_LEVEL_ID} label={label}>
      <UniversalSelect
        ariaLabel="Select status"
        formatOptionLabel={formatOptionLabel}
        id={`${TOP_LEVEL_ID}__select-status`}
        isSingleSelect={false}
        onChange={handleStatusChange}
        options={StatusOptions}
        placeholder=""
        value={status}
        withCheckBox
      />
    </InputGroupV2>
  );
};

export default StatusFilter;
